const API_RESPONSE_ERROR = 'API_RESPONSE_ERROR';
const CLEAR_ERROR_MSG = 'CLEAR_ERROR_MSG';

export default {
    API_RESPONSE_ERROR,
    CLEAR_ERROR_MSG,
};
